<template>
  <aside class="sidebar">
    <nav class="menu">
      <div class="sidebar_content flex-col">
        <div class="section_title_wrapper flex-row justify-between">
          <span class="section_title">课程</span>
        </div>
        <div
          class="sidebar_menu_item flex-row justify-between"
          @click="menuNavigator(0)"
          :class="{ item_active: idx == 0 }"
        >
          <img
            class="menu_item_icon"
            referrerpolicy="no-referrer"
            :src="
              require('@/assets/components/sidebar/FigmaDDSSlicePNG4020fb1c6ab947cc4249d55f0a8ad48d.png')
            "
          />
          <span class="menu_item_text">课程</span>
        </div>
        <div class="divider_line"></div>
        <div class="section_title_wrapper flex-row">
          <span class="section_title">学校</span>
        </div>
        <div
          class="sidebar_menu_item flex-row justify-between"
          @click="menuNavigator(1)"
          :class="{ item_active: idx == 1 }"
        >
          <img
            class="menu_item_icon"
            referrerpolicy="no-referrer"
            :src="
              require('@/assets/components/sidebar/FigmaDDSSlicePNG1df889433d09c0761c7fd05029aa1dd2.png')
            "
          />
          <span class="menu_item_text">班级</span>
        </div>
        <div
          class="sidebar_menu_item flex-row justify-between"
          @click="menuNavigator(2)"
          :class="{ item_active: idx == 2 }"
        >
          <img
            class="menu_item_icon"
            referrerpolicy="no-referrer"
            :src="
              require('@/assets/components/sidebar/FigmaDDSSlicePNG717d8ff70a657b45120d8d6140d18768.png')
            "
          />
          <span class="menu_item_text">学生</span>
        </div>
        <div
          class="sidebar_menu_item flex-row justify-between"
          @click="menuNavigator(3)"
          :class="{ item_active: idx == 3 }"
        >
          <img
            class="menu_item_icon"
            referrerpolicy="no-referrer"
            :src="
              require('@/assets/components/sidebar/FigmaDDSSlicePNGae4d355dd59036c6cb9a093bcecbd7a7.png')
            "
          />
          <span class="menu_item_text">比赛</span>
        </div>
      </div>
    </nav>
  </aside>
</template>

<script setup>
import { ref, onMounted, watch } from "vue"
import { useRoute, useRouter } from "vue-router"

const route = useRoute()
const router = useRouter()
const idx = ref(0)
const routes = [
  "TeacherCourses",
  "TeacherClasses",
  "TeacherStudents",
  "Competition",
]

const menuNavigator = (index) => {
  if (index >= 0 && index < routes.length) {
    router.push({
      name: routes[index],
    })
  }
}

onMounted(() => {
  switch (route.name) {
    case "TeacherCourses":
      idx.value = 0
      break
    case "TeacherClass":
    case "TeacherClasses":
      idx.value = 1
      break
    case "TeacherStudent":
    case "TeacherStudents":
      idx.value = 2
      break
    case "Competition":
      idx.value = 3
      break
  }
})

watch(
  () => route.name,
  (newName, oldName) => {
    switch (newName) {
      case "TeacherCourses":
        idx.value = 0
        break
      case "TeacherClass":
      case "TeacherClasses":
        idx.value = 1
        break
      case "TeacherStudent":
      case "TeacherStudents":
        idx.value = 2
        break
      case "Competition":
        idx.value = 3
        break
    }
  }
)
</script>

<style scoped>
.sidebar {
  width: 15vw;
  background-color: rgba(55, 91, 165, 1);
  color: white;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
  padding-top: 2vw;
  margin-top: 0;
  padding-top: 0;
}

.menu {
  display: flex;
  flex-direction: column;
  gap: 0.5vw;
}

.sidebar_content {
  position: relative;
  width: 15vw;
  height: auto;
  min-height: calc(100vh - 2.92vw);
  margin-bottom: 0.06vw;
}

.section_title_wrapper {
  width: 10vw;
  height: 1.72vw;
  margin: 0.88vw 0 0 1.45vw;
}

.section_title {
  width: 2.09vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(247, 251, 255, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin-top: 0.37vw;
}

.divider_line {
  background-color: rgba(217, 217, 217, 0.2);
  width: 15vw;
  height: 0.11vw;
  margin-top: 1.15vw;
}

.section_title {
  width: 2.09vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(247, 251, 255, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
}

.sidebar_menu_item {
  width: 15vw;
  height: 2.92vw;
  margin-top: 0.58vw;
  cursor: pointer;
}

.item_active,
.sidebar_menu_item:hover {
  background-color: rgba(61, 197, 255, 0.7);
  width: 15vw;
}

.menu_item_icon {
  width: 1.67vw;
  height: 1.67vw;
  margin: 0.62vw 0 0 2.7vw;
}

.menu_item_text {
  width: 2.09vw;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin: 0.78vw 8.02vw 0 0.83vw;
}
</style>
